import { render } from "./SzButtonGroup.vue?vue&type=template&id=2fae858a&scoped=true"
import script from "./SzButtonGroup.vue?vue&type=script&lang=ts"
export * from "./SzButtonGroup.vue?vue&type=script&lang=ts"

import "./SzButtonGroup.vue?vue&type=style&index=0&id=2fae858a&lang=less&scoped=true"
script.render = render
script.__scopeId = "data-v-2fae858a"

export default script